module.exports = __webpack_public_path__ + "media/images/check-cc804cc9c5ec42c930647447ec99af35.svg";